<script setup>
import { format } from '@formkit/tempo'
import Button from '@components/forms/Button.vue'

const props = defineProps({
	event: {
		type: Object,
		required: true,
	},
})
</script>

<template>
	<div class="relative flex w-full flex-col gap-3 overflow-hidden rounded-xl bg-black p-2 text-white lg:flex-row">
		<div class="grid aspect-video grid-cols-2 gap-2 lg:h-60">
			<template v-if="event.gallery.length < 3">
				<img class="col-span-2 h-full w-full overflow-hidden rounded-lg object-cover" :src="event.gallery[0]" :alt="event.name" />
			</template>
			<template v-else>
				<img class="h-full w-full overflow-hidden rounded-lg object-cover" :src="event.gallery[0]" :alt="event.name" />
				<div class="flex flex-col gap-2">
					<img class="aspect-video h-fit w-full overflow-hidden rounded-lg object-cover" :src="event.gallery[1]" :alt="event.name" />
					<img class="aspect-video h-fit w-full overflow-hidden rounded-lg object-cover" :src="event.gallery[2]" :alt="event.name" />
				</div>
			</template>
		</div>
		<div class="flex grow flex-col justify-between gap-5 p-3 lg:h-60">
			<div class="flex flex-row items-start justify-between gap-2">
				<h6 class="w-5/6 leading-none">{{ event.name }}</h6>
				<div class="flex items-center justify-center gap-2 rounded-md bg-snk-dark-200 px-2 py-1.5">
					<div class="mt-1 font-poppins text-sm font-semibold">+{{ event.gallery.length }}</div>
					<i class="fas fa-image" />
				</div>
			</div>
			<div class="flex flex-col gap-2">
				<div class="flex flex-row items-center gap-2">
					<i class="fas fa-clock text-snk-blue-500"></i>
					<div class="text-nowrap text-sm font-semibold uppercase leading-tight">{{ format(event.start_at, 'medium', 'UTC') }} - {{ format(event.finish_at, 'medium', 'UTC') }}</div>
				</div>
				<div class="flex flex-row items-center gap-2" v-if="event.game">
					<i class="fas fa-joystick text-snk-blue-500"></i>
					<div class="text-wrap text-sm font-semibold uppercase leading-tight">{{ event.game.name }}</div>
				</div>
				<div class="flex flex-row items-center gap-2" v-if="event.country">
					<i class="fas fa-location-dot text-snk-blue-500"></i>
					<div class="text-nowrap text-sm font-semibold uppercase leading-tight">{{ event.country.name }}</div>
				</div>
			</div>
			<div class="hidden gap-2">
				<!-- <Button class="wide secondary light wide" iconLeft="far fa-arrow-up-right-from-square" :href="event.external_url" v-if="event.external_url">Event Details</Button> -->
				<!-- <Button class="wide secondary light wide" :to="{ name: 'event', params: { slug: event.slug } }" v-else>Event Details</Button> -->
				<Button iconLeft="far fa-image" class="primary solid wide" :to="{ name: 'media', params: { slug: event.slug } }">View Media</Button>
			</div>
			<div class="flex flex-col gap-2">
				<!-- <Button class="wide secondary light thin" iconLeft="far fa-arrow-up-right-from-square" :href="event.external_url" v-if="event.external_url">Event Details</Button> -->
				<!-- <Button class="wide secondary light thin" :to="{ name: 'event', params: { slug: event.slug } }" v-else>Event Details</Button> -->
				<Button iconLeft="far fa-image" class="primary solid wide thin" :to="{ name: 'media', params: { slug: event.slug } }">View Media</Button>
			</div>
		</div>
	</div>
</template>
